import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../context/store';
import toast from 'react-hot-toast';

const C = { prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',or:'#C9A84C',creme:'#FDF6EC',cremeD:'#F5E8D3',noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86' };

export default function Register() {
  const [form, setForm] = useState({ nom: '', email: '', telephone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuthStore();
  const navigate = useNavigate();
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.password.length < 8) return toast.error('Mot de passe minimum 8 caractères');
    setLoading(true);
    try {
      await register(form);
      toast.success('Compte créé ! Bienvenue chez Fabi Luxe 🌺');
      navigate('/boutique');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur lors de l\'inscription');
    } finally { setLoading(false); }
  };

  const inp = { width: '100%', padding: '12px 16px', border: `1.5px solid ${C.cremeD}`, borderRadius: 10, fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none', color: C.noir, background: 'white', boxSizing: 'border-box', transition: 'border-color .2s' };
  const lbl = { display: 'block', fontSize: 11, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.1em', color: C.grisM, marginBottom: 8 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: C.creme }}>
      {/* Panneau gauche */}
      <div style={{ flex: 1, background: `linear-gradient(135deg, ${C.pruneD} 0%, ${C.prune} 60%, ${C.pruneL} 100%)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 48, minWidth: 0 }}>
        <div style={{ textAlign: 'center', color: C.creme }}>
          <div style={{ width: 72, height: 72, background: 'rgba(201,168,76,.15)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontFamily: 'Georgia,serif', fontSize: 28, fontWeight: 600, color: C.or, border: '1px solid rgba(201,168,76,.3)' }}>FL</div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 36, marginBottom: 16 }}>Rejoignez Fabi Luxe</h1>
          <p style={{ fontSize: 15, opacity: .7, lineHeight: 1.8 }}>Créez votre compte et profitez<br/>d'avantages exclusifs</p>
          <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 12 }}>
            {['✓ Suivi de commandes en temps réel','✓ Accès aux promotions exclusives','✓ Commande rapide via WhatsApp','✓ Livraison partout en Côte d\'Ivoire'].map(a => (
              <div key={a} style={{ display: 'flex', alignItems: 'center', gap: 10, color: C.creme, fontSize: 13, opacity: .85 }}>
                <span style={{ color: C.or }}>{a.substring(0,1)}</span>
                <span>{a.substring(2)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Formulaire */}
      <div style={{ width: 500, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 40px', background: 'white', overflowY: 'auto' }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <h2 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 30, color: C.pruneD, marginBottom: 8 }}>Créer un compte</h2>
          <p style={{ color: C.grisM, fontSize: 14, marginBottom: 32 }}>Tous les champs sont obligatoires</p>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {[
              { label: 'Nom complet', key: 'nom', type: 'text', placeholder: 'Aminata Koné' },
              { label: 'Adresse email', key: 'email', type: 'email', placeholder: 'votre@email.com' },
              { label: 'Téléphone CI', key: 'telephone', type: 'tel', placeholder: '07 XX XX XX XX' },
              { label: 'Mot de passe (8 caractères min.)', key: 'password', type: 'password', placeholder: '••••••••' },
            ].map(f => (
              <div key={f.key}>
                <label style={lbl}>{f.label}</label>
                <input type={f.type} value={form[f.key]} onChange={set(f.key)} placeholder={f.placeholder} required style={inp}
                  onFocus={e => e.target.style.borderColor = C.prune}
                  onBlur={e => e.target.style.borderColor = C.cremeD} />
              </div>
            ))}
            <button type="submit" disabled={loading} style={{ padding: '14px', background: loading ? C.grisM : `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, color: C.or, border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'DM Sans, sans-serif', boxShadow: loading ? 'none' : `0 4px 20px rgba(74,25,66,.3)`, marginTop: 8 }}>
              {loading ? '⏳ Création...' : 'Créer mon compte →'}
            </button>
          </form>
          <div style={{ marginTop: 24, paddingTop: 24, borderTop: `1px solid ${C.cremeD}`, textAlign: 'center' }}>
            <p style={{ fontSize: 14, color: C.grisM }}>Déjà un compte ?{' '}
              <Link to="/connexion" style={{ color: C.prune, fontWeight: 600, textDecoration: 'none' }}>Se connecter</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
